<div class="spacer"></div>
<section class="header bg-white"
	id="header">
	<div class="container-fluid px-xl-5">
		<div class="header__content d-flex align-items-center w-100">
			<div class="d-flex align-items-center w-100">
				<div class="d-flex flex-column flex-1">
					<div class="header__title">
						<a href="tel:{{(publicTelNo$ | async)}}"
							target="_blank"
							gaEvent="click_phone_number"
							gaCategory="Contact"
							gaBind="click"
							fbqEvent="click_phone_number"
							fbqBind="click"
							class="d-flex align-items-center font-weight-bold">
							<svg-icon src="assets/images/icon-phone.svg"
								class="me-2"></svg-icon>
                            {{(publicTelNo$ | async) | strReplace: '+44': '0'}}
						</a>
					</div>
					<!-- <p class="header__sub-title mb-0">{{(settings$ | async).headerSubText}}</p> -->
				</div>
				<div class="d-flex flex-1 justify-content-center">
					<a [href]="'/'"
						[routerLink]="['/']">
						<svg-icon [svgClass]="'header__logo-img'"
							src="assets/images/ys-logo-text.svg"></svg-icon>
					</a>
				</div>
				<div *ngIf="!(user$ | async)"
					class="d-flex flex-1 justify-content-end align-items-center text-end">
					<a [routerLink]="['/contact-us']"
						gaEvent="header_cta_quote"
						gaCategory="Contact"
						gaBind="click"
						class="btn btn-primary btn-sm me-4">
						Get a free quote
					</a>
					<a [href]="'/login'"
						[routerLink]="['/login']"
						class="header-sub-item-icon">
						<svg-icon src="assets/images/icon-user.svg"></svg-icon>
					</a>
					<a [href]="'/my-favourites'"
						[routerLink]="['/my-favourites']"
						class="header-sub-item-icon">
						<svg-icon src="assets/images/icon-heart.svg"></svg-icon>
						<span *ngIf="(favourites$ | async).length"
							class="badge-count">
							{{(favourites$ |
                            async).length}}
						</span>
					</a>
					<a [href]="'/basket'"
						[routerLink]="['/basket']"
						class="header-sub-item-icon me-0">
						<svg-icon src="assets/images/icon-cart.svg"></svg-icon>
						<span *ngIf="(basket$ | async).items.length || (basket$ | async).samples?.length"
							class="badge-count">
							{{(basket$ | async).items.length + (basket$ |
                            async).samples?.length}}
						</span>
					</a>
				</div>
				<div *ngIf="(user$ | async)"
					class="d-flex flex-1 justify-content-end align-items-center text-end">
					<a [routerLink]="['/contact-us']"
						class="btn btn-primary btn-sm me-4">
						Get a free quote
					</a>
					<a href="javascript:void(0)"
						class="header-sub-item-icon dropdown"
						appDropdown>
						<svg-icon src="assets/images/icon-user.svg"></svg-icon>
						<div class="dropdown-menu dropdown-menu-end dropdown-menu-user shadow-sm px-4 py-3">
							<a [routerLink]="['/account']"
								class="dropdown-item fw-bold text-primary small px-0 mb-2">
								My Account
							</a>
							<a [routerLink]="['/my-favourites']"
								class="dropdown-item fw-bold text-primary small px-0 mb-2">
								Favourites
							</a>
							<div class="dropdown-divider mt-0 mb-2"></div>
							<a [routerLink]="['/signout']"
								class="dropdown-item fw-bold text-primary px-0 small">
								Sign out
							</a>
						</div>
					</a>
					<a appDropdown
						class="header-sub-item-icon dropdown"
						href="javascript:void(0)">
						<svg-icon src="assets/images/icon-bell.svg"></svg-icon>
						<div *ngIf="(notifications$ | async).unread > 0"
							class="badge-count">
							{{(notifications$ |
                            async).unread}}
						</div>
						<div class="dropdown-menu dropdown-menu-end dropdown-menu-notifications shadow-sm">
							<app-notifications-list></app-notifications-list>
						</div>
					</a>
					<a [href]="'/my-favourites'"
						[routerLink]="['/my-favourites']"
						class="header-sub-item-icon">
						<svg-icon src="assets/images/icon-heart.svg"></svg-icon>
						<span *ngIf="(favourites$ | async).length"
							class="badge-count">
							{{(favourites$ |
                            async).length}}
						</span>
					</a>
					<a [routerLink]="['/basket']"
						class="header-sub-item-icon me-0">
						<svg-icon src="assets/images/icon-cart.svg"></svg-icon>
						<span *ngIf="(basket$ | async).items.length || (basket$ | async)?.samples?.length"
							class="badge-count">
							{{(basket$ | async).items.length + (basket$ |
                            async)?.samples?.length}}
						</span>
					</a>
				</div>
			</div>
		</div>
	</div>
	<div class="container-fluid bg-slate p-0">
		<div class="container-menu">
			<div class="d-flex justify-content-between align-items-center">
				<div class="w-100">
					<nav class="navbar navbar-expand-lg navbar-dark bg-slate"
						id="header-nav">
						<ul class="navbar-nav d-flex align-items-center w-100"
							style="height: 40px;">
							<ng-container *ngFor="let q of (menu$ | async).home; let m = index; let last = last">
								<ng-container *ngIf="m < 3">
									<li *ngIf="q.external === 1"
										[ngClass]="{'me-auto' : !last}"
										class="nav-item">
										<a [href]="[q.externalURL]"
											class="nav-link"
											target="_blank">
											{{q.name | titlecase}}
										</a>
									</li>
									<li *ngIf="q.external === 0"
										[ngClass]="{'dropdown' : q.submenu.length, 'show' : q.open, 'me-auto' : !last}"
										(mouseleave)="closeSubMenu(q)"
										(mouseover)="setActiveMenuImage(q, q.submenu[0], 'menuTrigger')"
										class="nav-item">
										<a [ngClass]="{'dropdown-toggle-chevron' : q.submenu.length}"
											[href]="[q.route]"
											[routerLink]="[q.route]"
											(click)="clickSubMenuParent(q)"
											class="nav-link">
											{{q.name | titlecase}}
										</a>
										<div *ngIf="q.submenu.length"
											[ngClass]="{'show' : q.open}"
											class="shadow">
											<div (mouseleave)="closeSubMenu(q)"
												class="d-flex justify-content-between">
												<div class="menu-links-holder">
													<div *ngFor="let subItem of q.submenu"
														(click)="closeSubMenu(q)"
														(mouseover)="setActiveMenuImage(q, subItem, 'optionTrigger')"
														class="dropdown-menu-option">
														<a *ngIf="q.route === '/product-groups'"
															[routerLink]="['/product-groups', subItem.slug]"
															class="dropdown-item">
															{{subItem.name | titlecase}}
														</a>
														<a *ngIf="q.route === '/product-ranges'"
															[routerLink]="['/product-ranges', subItem.slug]"
															class="dropdown-item">
															{{subItem.name | titlecase}}
														</a>
													</div>
												</div>
												<div class="menu-image-holder">
													<img *ngIf="activeMenuImage"
														[src]="activeMenuImage + '?width=175'"
														loading="eager"
														class="menu-image">
												</div>
											</div>
										</div>
									</li>
								</ng-container>
							</ng-container>
						</ul>
						<div class="mx-auto">
							<a [routerLink]="['/']"
								class="nav-link m-0 text-center">
								<svg-icon [ngClass]="'mx-auto'"
									[svgClass]="'header-logo-icon'"
									src="assets/images/ys-logo-icon.svg">
								</svg-icon>
							</a>
						</div>
						<ul class="navbar-nav d-flex justify-content-center align-items-center w-100"
							style="height: 40px;">
							<ng-container *ngFor="let q of (menu$ | async).home; let m = index; let first = first">
								<ng-container *ngIf="m > 2">
									<li *ngIf="q.external === 1"
										[ngClass]="{'ms-auto' : !first}"
										class="nav-item">
										<a [href]="[q.externalURL]"
											class="nav-link"
											target="_blank">
											{{q.name | titlecase}}
										</a>
									</li>
									<li *ngIf="q.external === 0"
										[ngClass]="{'dropdown' : q.submenu.length, 'show' : q.open, 'ms-auto' : !first}"
										(mouseleave)="closeSubMenu(q)"
										(mouseover)="setActiveMenuImage(q, q.submenu[0], 'menuTrigger')"
										class="nav-item">
										<a [ngClass]="{'dropdown-toggle-chevron' : q.submenu.length}"
											[href]="[q.route]"
											[routerLink]="[q.route]"
											class="nav-link">
											{{q.name | titlecase}}
										</a>
										<div *ngIf="q.submenu.length"
											[ngClass]="{'show' : q.open}"
											class="submenu shadow">
											<div (mouseleave)="closeSubMenu(q)"
												class="d-flex justify-content-between">
												<div class="menu-links-holder d-flex flex-column h-100">
													<div *ngFor="let subItem of q.submenu; let last = last"
														[ngClass]="{'dropdown-menu-option--margin' : !last}"
														(click)="closeSubMenu(q)"
														(mouseover)="setActiveMenuImage(q, subItem, 'optionTrigger')"
														class="dropdown-menu-option">
														<a [routerLink]="[subItem.route]"
															class="dropdown-item">
															{{subItem.name | titlecase}}
														</a>
													</div>
												</div>
											</div>
										</div>
									</li>
								</ng-container>
							</ng-container>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- <app-promo-bar *ngIf="showPromoBar"></app-promo-bar> -->
<!-- <app-confirmation (complete)="confirmationComplete($event)" *ngIf="confirmationData.open"
                  [data]="confirmationData"></app-confirmation> -->
